module.exports = __webpack_public_path__ + "3f16e137/img/verified-icon.f93bbc14.svg";